(() => {
  const country = document.documentElement.dataset.ocCountry;
  if (country !== 'US' && country !== 'GB') return;
  const words = country === 'US' ? {
    colour: 'color', colours: 'colors', coloured: 'colored', colourful: 'colorful', colouring: 'coloring',
    favourite: 'favorite', favourites: 'favorites', personalise: 'personalize', personalised: 'personalized',
    personalising: 'personalizing', personalisation: 'personalization', customise: 'customize', customised: 'customized',
    customising: 'customizing', customisation: 'customization', organise: 'organize', organised: 'organized',
    organising: 'organizing', organisation: 'organization', cosy: 'cozy', grey: 'gray', jewellery: 'jewelry',
    centre: 'center', centres: 'centers', centimetre: 'centimeter', centimetres: 'centimeters',
    millimetre: 'millimeter', millimetres: 'millimeters', litre: 'liter', litres: 'liters',
    travelled: 'traveled', travelling: 'traveling', cancelled: 'canceled', cancelling: 'canceling',
    dispatch: 'ship', dispatched: 'shipped', dispatches: 'ships', dispatching: 'shipping',
    'working days': 'business days'
  } : { 'business days': 'working days', 'standard shipping': 'standard delivery' };
  const pattern = new RegExp('\\b(' + Object.keys(words).sort((a, b) => b.length - a.length).join('|') + ')\\b', 'gi');
  const excluded = 'script,style,noscript,textarea,input,code,pre,svg,address,[contenteditable], [translate="no"],.jdgm-widget,.loox-reviews-default,[data-oc-reviews],.craft-trust,.roundreasons,#OCRegionForm';
  function convert(value) {
    return value.replace(pattern, match => {
      const replacement = words[match.toLowerCase()];
      if (match === match.toUpperCase()) return replacement.toUpperCase();
      return /^[A-Z]/.test(match) ? replacement[0].toUpperCase() + replacement.slice(1) : replacement;
    });
  }
  function text(node) {
    if (!node.parentElement || node.parentElement.closest(excluded)) return;
    const next = convert(node.nodeValue);
    if (next !== node.nodeValue) node.nodeValue = next;
  }
  function attributes(element) {
    if (element.closest(excluded)) return;
    for (const name of ['alt', 'aria-label', 'title', 'placeholder']) {
      const value = element.getAttribute(name);
      if (value) {
        const next = convert(value);
        if (value !== next) element.setAttribute(name, next);
      }
    }
  }
  function localize(root) {
    if (root.nodeType === Node.TEXT_NODE) { text(root); return; }
    if (root.nodeType !== Node.ELEMENT_NODE || root.closest(excluded)) return;
    attributes(root);
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        return node.nodeType === Node.ELEMENT_NODE && node.matches(excluded) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
      }
    });
    let node;
    while ((node = walker.nextNode())) {
      if (node.nodeType === Node.TEXT_NODE) text(node);
      else attributes(node);
    }
  }
  const observer = new MutationObserver(records => {
    observer.disconnect();
    for (const record of records) {
      if (record.type === 'characterData') text(record.target);
      else if (record.type === 'attributes') attributes(record.target);
      else record.addedNodes.forEach(localize);
    }
    observe();
  });
  function observe() {
    observer.observe(document.body, {subtree:true, childList:true, characterData:true, attributes:true, attributeFilter:['alt','aria-label','title','placeholder']});
  }
  localize(document.body);
  observe();
})();
